<template>
  <div>
    <div class="nav is-flex has-background-light">
      <a @click="$router.back()">
        <span class="icon is-small has-text-primary">
          <i class="fas fa-arrow-left"></i>
        </span>
      </a>
      <figure>
        <img class="logo" src="../assets/images/logo.png" />
      </figure>
    </div>
    <main class="columns is-centered has-background-light">
      <div class="column is-full-mobile is-11-tablet">
        <div class="section">
          <div class="columns">
            <div class="column box">
              <SolicitaçãoDetail
                v-bind="detail"
                :loading="loadingDeps"
                v-if="detail.tpSolicitacao === 'Solicitação de Compra'"
              />
              <PedidoDetail v-bind="detail" :loading="loadingDeps" v-if="detail.tpSolicitacao === 'Pedido de Compra'" />
              <AdiantamentoDetail v-bind="detail" :loading="loadingDeps" v-if="detail.tpSolicitacao === 'Adiantamento'" />
            </div>
            <div class="column box">
              <h2
                class="content has-text-centered title is-6 has-text-grey-dark"
              >
                Aprovação
              </h2>
              <div
                class="card aprovador"
                v-for="(person, index) in aprovadoresFechados"
                :key="index"
              >
                <div class="card-content">
                  <div class="columns is-mobile level">
                    <div class="column is-four-fifths">
                      <p class="title is-5">{{ person.aprovador }}</p>
                      <p class="subtitle is-6">
                        {{ formattedDate(person.data) }}
                      </p>
                    </div>
                    <div class="column has-text-right level-item">
                      <span class="icon is-size-3" v-if="person.status === 'A'">
                        <i class="fa fa-check has-text-primary"></i>
                      </span>
                      <span class="icon is-size-3" v-if="person.status === 'R'">
                        <i class="fa fa-times has-text-danger"></i>
                      </span>
                    </div>
                  </div>
                  <div
                    v-if="
                      aprovadorAtual.ruleName &&
                      aprovadorAtual.ruleName.length > 1
                    "
                  >
                    <div
                      class="columns is-mobile mt-2"
                      v-for="(ruleName, index) in aprovadorAtual.ruleName"
                      :key="ruleName"
                    >
                      <div class="column">
                        <p class="subtitle is-6">
                          {{ ruleName }}
                        </p>
                      </div>
                      <div class="column has-text-right">
                        <p class="subtitle is-6">
                          {{
                            formattedPrice(
                              aprovadorAtual.lineTotal[index],
                              docCur
                            )
                          }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="card-content has-background-light"
                  v-if="person.observacoes"
                >
                  <div class="columns">
                    <div class="column">
                      <p class="title is-6">Observação</p>
                      <p class="subtitle is-6">{{ person.observacoes }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card aprovador" v-if="showAprovadorAtual">
                <div class="card-content">
                  <div class="columns is-mobile level">
                    <div class="column is-four-fifths">
                      <p class="title is-5">
                        {{ aprovadorAtual.aprovador }}
                      </p>
                    </div>
                    <div class="column has-text-right level-item">
                      <span class="icon is-size-3" v-if="status === 'A'">
                        <i class="fa fa-check has-text-primary"></i>
                      </span>
                      <span class="icon is-size-3" v-if="status === 'R'">
                        <i class="fa fa-times has-text-danger"></i>
                      </span>
                    </div>
                  </div>
                  <div
                    v-if="
                      aprovadorAtual.ruleName &&
                      aprovadorAtual.ruleName.length > 1
                    "
                  >
                    <div
                      class="columns is-mobile mt-2"
                      v-for="(ruleName, index) in aprovadorAtual.ruleName"
                      :key="ruleName"
                    >
                      <div class="column">
                        <p class="subtitle is-6">
                          {{ ruleName }}
                        </p>
                      </div>
                      <div class="column has-text-right">
                        <p class="subtitle is-6">
                          {{
                            formattedPrice(
                              aprovadorAtual.lineTotal[index],
                              docCur
                            )
                          }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-content has-background-light" v-if="personObs">
                  <div class="columns is-mobile level">
                    <div class="column is-four-fifths">
                      <p class="title is-6">Observação</p>
                      <p class="subtitle is-6">{{ personObs }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="aprovadoresAbertos.length > 1"></div>
              <div
                class="card aprovador"
                v-for="(person, index) in aprovadoresAbertos"
                :key="index"
              >
                <div class="card-content">
                  <div class="columns is-mobile level">
                    <div class="column is-four-fifths">
                      <p class="title is-5">{{ person.aprovador }}</p>
                    </div>
                  </div>
                  <div
                    v-if="
                      aprovadorAtual.ruleName &&
                      aprovadorAtual.ruleName.length > 1
                    "
                  >
                    <div
                      class="columns is-mobile mt-2"
                      v-for="(ruleName, index) in aprovadorAtual.ruleName"
                      :key="ruleName"
                    >
                      <div class="column">
                        <p class="subtitle is-6">
                          {{ ruleName }}
                        </p>
                      </div>
                      <div class="column has-text-right">
                        <p class="subtitle is-6">
                          {{
                            formattedPrice(
                              aprovadorAtual.lineTotal[index],
                              docCur
                            )
                          }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <p>&#160;</p>
              <div class="card" v-if="!personObs && status === null">
                <div class="card-content control">
                  <label for="obs" class="title is-6">Observação</label>
                  <textarea
                    id="obs"
                    class="textarea has-fixed-size"
                    placeholder="Adicione uma observação"
                    v-model="obs"
                    rows="2"
                  ></textarea>
                </div>
                <div
                  @click="addObs()"
                  class="card-content has-background-grey-lighter has-text-centered"
                >
                  <div class="is-flex level-item">
                    <span class="icon is-small">
                      <i class="fas fa-plus"></i>
                    </span>
                    <p>&#160;&#160;Add observação</p>
                  </div>
                </div>
              </div>
              <p>&#160;</p>
              <div class="aprovacao" v-show="status === null" v-if="!loading">
                <p class="has-text-danger has-text-centered" v-if="missObs">
                  Por favor, adicione uma observação.
                </p>
                <p class="has-text-danger has-text-centered" v-if="failSave">
                  Falha ao salvar, tente novamente.
                </p>
                <h2 class="content has-text-centered">
                  Deseja aprovar esta solicitação de compra?
                </h2>
                <div
                  class="buttons are-small content is-centered has-text-weight-bold"
                >
                  <a @click="approved()" class="button is-outlined is-primary">
                    Aprovar
                  </a>
                  <a @click="declined()" class="button is-outlined is-danger">
                    Declinar
                  </a>
                </div>
              </div>
              <div class="level-item" v-if="loading">
                <div class="lds-ring">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import SolicitaçãoDetail from "../components/SolicitaçãoDetail.vue";
import PedidoDetail from "../components/PedidoDetail.vue";
import { getDocEntry, save } from "../repository.js";
import detailMixin from "../components/detailMixin";
import dayjs from "dayjs";
import AdiantamentoDetail from '../components/AdiantamentoDetail.vue';

export default {
  name: "detail",
  components: {
    SolicitaçãoDetail,
    PedidoDetail,
    AdiantamentoDetail,
  },
  data() {
    return {
      status: null,
      personObs: null,
      obs: null,
      detail: {
        approval: [],
      },
      loading: false,
      missObs: false,
      failSave: false,
      failSaveMsg: "",
      loadingDeps: false,
    };
  },
  mixins: [detailMixin],
  created() {
    if (window.sessionStorage.getItem("isLogged") === null) {
      this.$router.push({ name: "login" });
      return;
    }

    this.getDetail(this.id);
  },
  computed: {
    showAprovadorAtual() {
      return !(
        Object.keys(this.aprovadorAtual).length === 0 &&
        this.aprovadorAtual.constructor === Object
      );
    },
    id() {
      return Number(this.$route.params.id);
    },
    aprovadores() {
      const { approval } = this.detail;
      const userIds = approval.map(({ userID }) => userID);
      const uniqArr = [...new Set(userIds)];

      return uniqArr
        .map((uniq) => approval.filter(({ userID }) => userID === uniq))
        .reduce((acc, cur) => {
          return [
            ...acc,
            {
              ...cur[0],
              docEntry: cur.map(({ docEntry }) => String(docEntry)),
              ruleName: cur.map(({ ruleName }) => ruleName),
              lineTotal: cur.map(({ lineTotal }) => lineTotal),
            },
          ];
        }, []);
    },
    aprovadoresFechados() {
      return this.aprovadores
        .filter(({ status }) => status === "A" || status === "R")
        .sort((a, b) => a.nivel - b.nivel);
    },
    aprovadorAtual() {
      const aprovador = this.aprovadores
        .filter(({ status }) => status !== "A" && status !== "R")
        .slice(0, 1);

      return aprovador.length === 0 ? {} : aprovador[0];
    },
    aprovadoresAbertos() {
      return this.aprovadores
        .filter(({ status }) => status !== "A" && status !== "R")
        .slice(1)
        .sort((a, b) => a.nivel - b.nivel);
    },
  },
  methods: {
    setItemToSession(item) {
      if (sessionStorage.getItem(item.docNum)) {
        sessionStorage.removeItem(item.docNum);
      }
      sessionStorage.setItem(item.docNum, JSON.stringify(item));
    },
    getUserId() {
      return Number(localStorage.getItem("userId"));
    },
    async getDetail(id) {
      this.detail = await JSON.parse(sessionStorage.getItem(id));
      this.status = this.detail.status;

      const docEntries = this.detail.itens
        .filter((item) => item.baseEntry)
        .map((item) => item.baseEntry);
      const docEntriesUniq = [...new Set(docEntries)];

      if (docEntriesUniq.length > 0) {
        this.loadingDeps = true;
        await Promise.all(
          docEntriesUniq.map((doc) =>
            getDocEntry(this.getUserId(), doc).then(({ data }) => {
              if (data.docNum) {
                this.setItemToSession(data);
              }
            })
          )
        );
        this.loadingDeps = false;
      }
    },
    async saveDetail() {
      try {
        this.loading = true;
        const data = (doc) => ({
          docNum: this.detail.docNum,
          docEntry: parseInt(doc),
          objectType: this.detail.objectType,
          status: this.status,
          comments: this.personObs == null ? "" : this.personObs,
          user: this.getUserId(),
          datetime: dayjs().format(),
        });

        await save(this.aprovadorAtual.docEntry.map((doc) => data(doc)));

        this.$router.push({ name: "list" });
      } catch (err) {
        console.log("Falha ao salvar", err);
        this.status = null;
        this.failSave = true;
      } finally {
        this.loading = false;
      }
    },
    approved() {
      this.status = "A";
      this.saveDetail();
    },
    declined() {
      if (this.personObs) {
        this.status = "R";
        this.saveDetail();
        return;
      }
      this.missObs = true;
    },
    addObs() {
      if (this.obs) {
        this.personObs = this.obs;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
html,
body {
  height: 100%;
}
.section {
  padding: 1.5rem 1rem;
}

@media screen and (max-width: 768px) {
  .section,
  .box {
    padding: 0 1rem;
    box-sizing: content-box;
    box-shadow: none;
  }
}

.content {
  margin-bottom: 2rem;
}

.nav {
  height: 63px;
  margin-bottom: 0;
}

@media screen and (min-width: 769px) {
  .nav {
    justify-content: flex-start;
    padding-left: 5rem;
  }
}

.column {
  padding-top: 0;
  padding-bottom: 0;
}

.columns {
  padding-left: 0;
  padding-right: 0;
  margin: 0 -0.75rem;
}

main {
  min-height: calc(100vh - 63px);
}

@media screen and (max-width: 768px) {
  main {
    align-items: normal;
    margin-top: 1rem;
  }
}

.logo {
  height: 2.5rem;
  position: absolute;
  left: calc(50% - 3.1rem);
  top: calc(31.5px - 1.25rem);
}

.title-bar {
  color: white;
  background-color: #a0cf77;
  margin-bottom: 1rem;
}

.box {
  padding: 1rem;
  border-radius: 0;
  &.column {
    margin: 0;
  }
}

@media (min-width: 769px) {
  .box {
    padding: 2rem 2rem;
    &.column {
      margin: 0 1rem;
    }
  }
}

.button {
  width: 5rem;
  font-size: 14px !important;
  &:last-of-type {
    margin-left: 2rem !important;
  }
  .is-primary {
    border-color: #21ba45;
  }
}

span.icon {
  .fa-arrow-left {
    position: absolute;
    left: 1rem;
    top: 1.5rem;
  }
}

.card,
.card-content {
  border-radius: 0.75rem;

  &:last-child {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    cursor: pointer;
  }
}

.lds-ring {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 51px;
  height: 51px;
  margin: 6px;
  border: 6px solid #62ba46;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #62ba46 transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.aprovador {
  &:not(:first-of-type) {
    margin-top: 16px;
  }
}
</style>
